import React, { useState, useEffect } from "react";
import "../css/primium.css";
import { Link, useNavigate } from "react-router-dom";
import { branding } from "../utils/branding";
import VelaKoda from "../assets/Images/MobileLogo.svg";
import VelaLogo from "../assets/Images/ZeroBoxLogo.svg";

const PrimiumpPage = () => {
  const [billingCycle, setBillingCycle] = useState("monthly");
  const [selectedPlan, setSelectedPlan] = useState(null);
  const navigate = useNavigate();

  const plans = [
    {
      name: "Starter Plan",
      price: "$29",
      type: "month",
      description: branding("ZeroBox Online"),
      features: [
        "Web-based access",
        "Basic chatbot functionality",
        "Limited customization",
      ],
    },
    {
      name: "Developer Plan",
      price: "$79",
      type: "month",
      description: branding("ZeroBox Connect"),
      features: [
        "All Online features",
        "Full API access",
        "Integration with external tools",
      ],
    },
    {
      name: "Edge Local Plan",
      price: "Custom",
      type: "one-time + license",
      description: branding("ZeroBox Edge"),
      features: [
        "Fully offline support",
        "Local data storage",
        "Sync when online",
      ],
    },
    {
      name: "Cloud Enterprize Plan",
      price: "$149",
      type: "month",
      description: branding("ZeroBox Cloud"),
      features: [
        "Auto-scaling cloud deployment",
        "99.9% uptime",
        "Multi-user & analytics",
      ],
    },
    // {
    //   name: "Core Enterprize Plan",
    //   price: "Custom",
    //   type: "based on infra size",
    //   description: branding("ZeroBox Core (On-Prem Server)",
    //   features: ["Self-hosted", "Full customization", "Dedicated support & compliance tools"],
    // },
  ];

  // ✅ Initialize dark mode from localStorage (defaults to false)
  const [darkMode, setDarkMode] = useState(() => {
    return localStorage.getItem("darkMode") === "true";
  });

  // ✅ Apply dark mode class to <body> and persist state
  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("dark-mode");
    } else {
      document.body.classList.remove("dark-mode");
    }
    localStorage.setItem("darkMode", darkMode);
  }, [darkMode]);

  // ✅ Logo changes dynamically based on theme
  const logoSrc = darkMode
    ? "/asset/logo.png" // dark mode logo
    : "/asset/login-logo.png"; // light mode logo

  return (
    <div className="subscription-container container py-4">
      <div className="">
        <Link to="/">
          <img
            className=""
            src={VelaKoda}
            alt="VelaKoda Logo"
            style={{
              height: "40px",
              objectFit: "contain",
              marginBottom: "10px",
              width: "auto",
              cursor: "pointer", // optional, for better UX
            }}
          />
        </Link>
      </div>
      {/* Header */}
      <div className="mt-5 mb-2">
        <h2>
          <span className="highlight fs-3 ">Subscriptions</span>
          <span className="sub-title-inline">
            - Try new experiences with Premium features.
          </span>
        </h2>
        <p className="refresh-prompts ms-2">
          Choose the plan that's right for you
        </p>
      </div>

      {/* Billing Toggle */}
      <div className="billing-toggle d-flex justify-content-end mb-3">
        <span
          className={`billing-option ${
            billingCycle === "monthly" ? "active" : ""
          }`}
          onClick={() => setBillingCycle("monthly")}
        >
          Monthly
        </span>
        <span
          className={`billing-option ${
            billingCycle === "yearly" ? "active" : ""
          }`}
          onClick={() => setBillingCycle("yearly")}
        >
          Yearly
        </span>
      </div>

      {/* Plan Cards */}
      <div className="row g-4">
        {plans.map((plan, index) => (
          <div key={index} className="col-md-4 col-lg-3 col-sm-6">
            <div
              className={`plan-card card profile shadow-sm ${
                selectedPlan === index ? "selected" : ""
              }`}
              onClick={() => setSelectedPlan(index)}
            >
              <div className="card-body">
                <h5 className="card-title fw-bold">{plan.name}</h5>
                <h2 className="plan-price">
                  {plan.price}
                  {plan.price !== "Custom" && (
                    <span className="price-type">/{plan.type}</span>
                  )}
                </h2>
                <p className=" small">{plan.description}</p>
                <button className="custom-btn w-100">Get Started</button>
                <h6 className="fw-bold mt-3">Features:</h6>
                <ul className="features-list">
                  {plan.features.map((feature, i) => (
                    <li key={i}>{feature}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Footer Buttons */}
      <div className="d-flex justify-content-center gap-5 mt-4">
        <button
          className="cancle-btn px-5"
          onClick={() => navigate("/user/new")}
        >
          Back
        </button>

        <button className="custom-btn px-4">Continue</button>
      </div>
    </div>
  );
};

export default PrimiumpPage;
